import { makeStyles } from "@mui/styles";
import bgFlower from "../../assets/Teams/png/team-bg-banner.png";

export const DashBoardStyle = makeStyles((theme) => ({
  mainLayout: {
    overflow: "hidden",
    padding: [[30, 30, 45, 30]],
    position: "relative",
    height: "100%",
    zIndex: 2,
    background:
      "linear-gradient(92deg, #F6FCFF 7.06%, rgba(255, 244, 238, 0.50) 86.87%)",
    backgroundSize: "cover",
    minHeight: "calc(100vh - 105px)",
    "&:before": {
      position: "absolute",
      content: "''",
      left: 0,
      right: 0,
      top: 0,
      background: `url(${bgFlower})`,
      zIndex: -1,
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      minHeight: 310,
      [theme.breakpoints.down("sm")]: {
        minHeight: 140,
        backgroundSize: "cover",
        backgroundPosition: "0 -10px",
      },
    },
    [theme.breakpoints.down("sm")]: {
      padding: [[30, 16, 42, 16]],
    },
  },
  firstBox: {
    overflow: "visible",
    background: "#FCFCFD",
    padding: [[26, 30]],
    textAlign: "left",
    position: "relative",
    border: "1px solid #fff",
    boxShadow: "0px 7.798px 17.329px 0px rgba(81, 125, 132, 0.07)",
    [theme.breakpoints.down("xxl")]: {
      padding: 18,
    },
    [theme.breakpoints.down("md")]: {
      padding: [[18]],
    },
    "& h4": {
      color: "#3A3A40",
      lineHeight: "30px",
      fontSize: 34,
      fontWeight: 700,
      marginRight: 10,
      [theme.breakpoints.down("lg")]: {
        fontSize: 28,
      },
      [theme.breakpoints.down("md")]: {
        fontSize: 24,
      },
    },
    "& h6": {
      fontSize: 16,
      lineHeight: "20px",
      color: "var(--blackGray)",
      marginBottom: 18,
      [theme.breakpoints.down("md")]: {
        fontSize: 14,
        lineHeight: "18px",
        marginBottom: 13,
      },
    },
  },
  marketTends: {
    "&.MuiTypography-root": {
      color: "#86650A",
      fontWeight: "700",
    },
  },
  vasanaTypeImage: {
    marginLeft: 10,
    display: "inline-block",
    verticalAlign: "bottom",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 8,
    },
    "& img": {
      width: "76px",
      height: "44px",
      objectFit: "contain",
      objectPosition: "bottom",
      verticalAlign: "sub",
      [theme.breakpoints.down("md")]: {
        verticalAlign: "bottom",
      },
    },
  },
  vasanaTypeImage2: {
    marginLeft: 10,
    display: "inline-block",
    verticalAlign: "bottom",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 8,
    },
    "& img": {
      width: "32px",
      height: "32px",
      objectFit: "contain",
      objectPosition: "top",
      verticalAlign: "sub",
      [theme.breakpoints.down("md")]: {
        verticalAlign: "bottom",
      },
    },
  },
  personalityMain1: {
    minHeight: "204px",
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
      marginLeft: 0,
    },
    "& .swiper-button-next1": {
      transform: "rotate(180deg)",
    },
  },
  personalityMain: {
    minHeight: "204px",
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
      marginLeft: 0,
    },
    "& .swiper-button-next": {
      transform: "rotate(180deg)",
    },
  },
  customArrow: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    justifyContent: "space-between",
    zIndex: 2,
    height: 0,
    width: "calc(100% + 72px)",
    [theme.breakpoints.down("xxl")]: {
      width: "calc(100% + 36px)",
    },
    "& .swiper-button": {
      cursor: "pointer",
      boxShadow: "0px 0px 16px 0px #00000030",
      backgroundColor: "#ffffff",
      border: "2px solid var(--secondary)",
      borderRadius: "50%",
      color: "#000",
      height: 32,
      width: 32,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        height: 18,
        width: 18,
      },
      "&.swiper-button-disabled": {
        opacity: 0.5,
      },
      "&.image-swiper-button-next": {
        transform: "translate(-30%, -50%)",
        "& svg": {
          width: 12,
          height: 12,
        },
      },
      "&.image-swiper-button-prev": {
        transform: "translate(35%, -50%)",
        "& svg": {
          width: 12,
          height: 12,
        },
      },
    },
  },
  customArrow1: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    justifyContent: "space-between",
    zIndex: 2,
    height: 0,
    width: "calc(100% + 72px)",
    [theme.breakpoints.down("xxl")]: {
      width: "calc(100% + 36px)",
    },
    "& .swiper-button1": {
      cursor: "pointer",
      boxShadow: "0px 0px 16px 0px #00000030",
      backgroundColor: "#ffffff",
      border: "2px solid var(--Tertiary)",
      borderRadius: "50%",
      color: "#000",
      height: 32,
      width: 32,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        height: 18,
        width: 18,
      },
      "&.swiper-button-disabled1": {
        opacity: 0.5,
      },
      "&.image-swiper-button-next1": {
        transform: "translate(-35%, -50%)",
        "& svg": {
          width: 12,
          height: 12,
        },
      },
      "&.image-swiper-button-prev1": {
        transform: "translate(35%, -50%)",
        "& svg": {
          width: 12,
          height: 12,
        },
      },
    },
  },
  personalityBoxMain: {
    "& h5": {
      fontSize: 18,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: 16,
      textAlign: "left",
      color: "var(--blackGray)",
      "& img, .icon-wrapper": {
        marginRight: 10,
        objectFit: "none",
        height: 32,
        width: 32,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    "& p": {
      fontSize: 16,
      color: "var(--gray)",
      lineHeight: "21px",
    },
  },
  videosBox: {
    padding: [[16, 18, 24]],
    border: "none",
    boxShadow: "0px 7.798px 17.329px 0px rgba(81, 125, 132, 0.07)",
    height: "100%",
  },
  video: {
    width: "100%",
    height: 150,
    position: "relative",
  },
  videoImage: {
    height: "100%",
    width: "100%",
    objectFit: "cover",
    borderRadius: 8,
  },
  combinationHeading: {
    "& h5": {
      fontSize: 20,
      fontWeight: 700,
      textAlign: "left",
      lineHeight: "26px",
      color: "#4F4F4F",
      marginBottom: 5,
    },
    "& p": {
      fontSize: 16,
      lineHeight: "21px",
      color: "var(--gray)",
      textAlign: "left",
      marginLeft: 5,
      [theme.breakpoints.down("md")]: {
        fontSize: 14,
        lineHeight: "18px",
      },
    },
    "& img": {
      marginRight: 10,
      marginLeft: 10,
    },
  },
  personalityRangeBox: {
    width: "25%",
    padding: "0 10px",
    [theme.breakpoints.down("1640")]: {
      width: "50%",
    },
    [theme.breakpoints.down("slg")]: {
      width: "100%",
    },
  },
  vassnaTypeBox: {
    gap: 20,
    marginTop: 20,
    "& a": {
      width: "calc(50% - 10px)",
      [theme.breakpoints.down("slg")]: {
        width: "100%",
      },
    },
  },
  personalityRange: {
    padding: [[12, 24]],
    borderRadius: 10,
    transition: "all 0.5s",
    border: "1px solid rgba(79, 79, 79, 0.10)",
    cursor: "pointer",
    "&:hover": {
      boxShadow: "0px 7px 4px 0px rgba(171, 148, 177, 0.10)",
      transition: "all 0.5s",
      "& .MuiBox-root": {
        "&  .MuiCircularProgress-root .MuiCircularProgress-svg": {
          boxShadow: "0px 0px 0px 4px rgb(255 255 255 / 100%) inset",
        },
        "& .MuiBox-root .MuiBox-root": {
          background: "var(--white)",
        },
      },
    },
    "& sapn": {
      lineHeight: 0,
    },
    [theme.breakpoints.down("lg")]: {
      padding: 12,
    },
    [theme.breakpoints.down("sm")]: {
      padding: 6,
    },
    "& h4": {
      flex: "none",
      minWidth: 73,
      textAlign: "left",
      "& img": {
        height: 40,
        width: "80%",
      },
    },
    "& p": {
      fontSize: 16,
      lineHeight: "18px",
      color: "var(--gray)",
      marginLeft: 6,
      textAlign: "left",
    },
    "&.saPer": {
      "&:hover": {
        borderColor: "#8304A3",
        background:
          "linear-gradient(92deg, rgba(242, 231, 245, 0.50) 1.56%, rgba(242, 231, 245, 0.00) 77.91%)",
        "& p": {
          color: "#8B3F9E",
        },
      },
    },
    "&.rePer": {
      "&:hover": {
        borderColor: "#3498DB",
        background:
          "linear-gradient(92deg, rgba(227, 241, 249, 0.50) 1.56%, rgba(227, 241, 249, 0.00) 77.91%)",
        "& p": {
          color: "#3498DB",
        },
      },
    },
    "&.gaPer": {
      "&:hover": {
        borderColor: "#FFB142",
        background:
          "linear-gradient(92deg, rgba(255, 224, 180, 0.20) 1.56%, rgba(255, 224, 180, 0.00) 77.91%)",
        "& p": {
          color: "#FFB142",
        },
      },
    },
    "&.maPer": {
      "&:hover": {
        borderColor: "#56A06F",
        background:
          "linear-gradient(92deg, rgba(200, 233, 211, 0.25) 1.56%, rgba(200, 233, 211, 0.00) 77.91%)",
        "& p": {
          color: "#56A06F",
        },
      },
    },
  },
  range: {
    lineHeight: "0",
    marginRight: 22,
    [theme.breakpoints.down("md")]: {
      marginRight: 16,
    },
  },

  rangeInfo: {
    display: "flex",
    marginLeft: 20,
    alignItems: "center",
    [theme.breakpoints.down("1750")]: {
      flexWrap: "wrap",
    },
    "& h4": {
      flex: "none",
      minWidth: 73,
      textAlign: "left",
      "& img": {
        height: 45,
        width: "auto",
      },
    },
    "& p": {
      fontSize: 16,
      lineHeight: "18px",
      color: "var(--gray)",
      textAlign: "left",
      [theme.breakpoints.up("1750")]: {
        marginLeft: 10,
      },
    },
  },
  description: {
    padding: [[20]],
    "& .MuiTypography-root": {
      padding: [[3, 0]],
    },
  },
  yourPersonalitySliderMain: {
    "& .swiper": {
      padding: [[36, 27, 26]],
      [theme.breakpoints.down("sm")]: {
        padding: [[20, 20, 30]],
      },
      "& .swiper-slide": {
        height: "auto",
      },
      "& .swiper-pagination": {
        bottom: 0,
        "& .swiper-pagination-bullet": {
          background: "#DFE1F84D",
          opacity: 1,
          width: 24,
          height: 4,
          transition: "all 0.4s ease-in-out",
          borderRadius: 4,
        },
        "& .swiper-pagination-bullet-active": {
          background: "var(--primary)",
          width: 11,
        },
      },
    },
  },
  videoSlider: {
    "& .swiper": {
      padding: [[0, 4]],
    },
  },
  mdHeading: {
    "&.MuiTypography-root": {
      fontSize: 20,
      lineHeight: "26px",
      fontWeight: 700,
    },
  },
  contentDescription: {
    textAlign: "left",
    marginTop: 16,
    "& span": {
      fontSize: 12,
      color: "var(--gray)",
      fontWeight: 500,
      lineHeight: "15px",
    },
  },
  desc: {
    "&.MuiTypography-root": {
      fontSize: 14,
      color: "var(--gray)",
      lineHeight: "20px",
    },
  },
  quickViewContent2: {
    "&.MuiStack-root": {
      [theme.breakpoints.down("1456")]: {
        position: "absolute",
        right: 20,
        top: 80,
        maxWidth: 500,
        zIndex: 9,
        width: "calc(100% - 40px)",
      },
    },
    "&.MuiGrid-item": {
      [theme.breakpoints.down("md")]: {
        paddingTop: "0px !important",
      },
    },
  },
  vasanatype: {
    "& h4": {
      display: "inline-block",
      marginRight: 0,
    },
  },
  lgHeading: {
    "&.MuiTypography-root": {
      fontSize: 26,
      fontWeight: "700",
      color: "#4F4F4F",
      lineHeight: "30px",
      [theme.breakpoints.down("md")]: {
        fontSize: 22,
        lineHeight: "24px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
        lineHeight: "22px",
      },
    },
  },
  backImageOne: {
    minHeight: "264px",
    width: "calc(100% - 1.5px)",
    position: "absolute",
    transform: "rotate(-4deg)",
    boxShadow: "0px 0px 24px 0px #0000000F",
    height: "100%",
    [theme.breakpoints.between(1366, 1700)]: {
      minHeight: 254,
    },
  },
  backImageTwo: {
    minHeight: "264px",
    width: "calc(100% - 1.5px)",
    position: "absolute",
    transform: "rotate(4deg)",
    boxShadow: "0px 0px 24px 0px #0000000F",
    height: "100%",
    [theme.breakpoints.between(1366, 1700)]: {
      minHeight: 254,
    },
  },
  backImageThree: {
    minHeight: "264px",
    width: "calc(100% - 1.5px)",
    position: "absolute",
    transform: "rotate(2deg)",
    boxShadow: "0px 0px 24px 0px #0000000F",
    height: "100%",
    [theme.breakpoints.between(1366, 1700)]: {
      minHeight: 254,
    },
  },
  backImageFour: {
    minHeight: "264px",
    width: "calc(100% - 1.5px)",
    position: "absolute",
    transform: "rotate(-2deg)",
    boxShadow: "0px 0px 24px 0px #0000000F",
    height: "100%",
    [theme.breakpoints.between(1366, 1700)]: {
      minHeight: 254,
    },
  },
  exploreVasanaType: {
    marginTop: "auto",
    "& a": {
      display: "inline-flex",
      justifyContent: "flex-end",
      color: theme.palette.orange.main,
      [theme.breakpoints.down("xsm")]: {
        justifyContent: "flex-start",
      },
    },
  },
  viewAll: {
    "& a": {
      color: "#8B3F9E",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      fontWeight: 700,
      flex: "none",
    },
  },
  notificationIcon: {
    backgroundColor: "var(--primaryLighter)",
    borderRadius: 5,
    padding: "5px 8px",
    float: "right",
    marginBottom: 20,
  },
  emptyNotification: {
    height: "100%",
    minHeight: "200px",
    padding: "36px",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& svg": {
      color: "#898994",
    },
    "& p": {
      color: "#898994",
      fontSize: "20px",
      fontWeight: 500,
    },
  },
  notificationbox: {
    height: "100%",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: 8,
      padding: 4,
    },
    "&::-webkit-scrollbar-track": {
      background: "#F6F6FD",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 6,
      background: "var(--primary)",
      border: "0.5px solid #ffffff",
    },
  },
  singleNotification: {
    padding: "16px 0px",
    borderRadius: "5px",
    // cursor: "pointer",
    gap: "8px",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
  },
  assessmentDescription: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  imgWrapper: {
    "& img": {
      maxHeight: 130,
    },
  },
  GenderChangeModal: {
    "&.MuiModal-root": {
      "& .MuiPaper-root": {
        maxWidth: "385px",
      },
    },
  },
  btnComplete: {
    "&.MuiButton-root": {
      padding: "7px 14px",
      background: "#2D8F4E",
      fontWeight: 500,
      flex: "0 0 auto",
      minWidth: "auto",
      "& .content": {
        display: "flex",
        alignItems: "center",
        fontSize: 14,
        lineHeight: "16px",
        [theme.breakpoints.down("sm")]: {
          fontSize: 12,
        },
        "& svg": {
          height: 15,
          width: 15,
          marginRight: 8,
        },
      },
      "&:hover": {
        background: "#2D8F4E",
      },
    },
  },
  btnScadule: {
    "&.MuiButton-root": {
      padding: "7px 10px",
      background: "#FEF6EE",
      fontWeight: 500,
      color: "#E87637",
      width: "fit-content",
      flex: "0 0 auto",
      "& .content": {
        display: "flex",
        alignItems: "center",
        fontSize: 14,
        lineHeight: "16px",
        [theme.breakpoints.down("sm")]: {
          fontSize: 12,
        },
        "& svg": {
          height: 15,
          width: 15,
          marginRight: 8,
        },
      },
      "&:hover": {
        background: "#FEF6EE",
      },
    },
  },
  btnRequired: {
    "&.MuiButton-root": {
      padding: "7px 0px",
      background: "#555FDD0D",
      fontWeight: 500,
      width: "fit-content",
      color: "var(--Tertiary)",
      flex: "0 0 auto",
      "& .content": {
        display: "flex",
        alignItems: "center",
        fontSize: 14,
        lineHeight: "16px",
        [theme.breakpoints.down("sm")]: {
          fontSize: 12,
        },
        "& svg": {
          height: 18,
          width: 15,
          marginRight: 6,
        },
      },
      "&:hover": {
        background: "#555FDD0D",
      },
    },
  },
  takeAssessmentBtn: {
    "&.MuiButton-root": {
      padding: "5px 0px 5px 5px",
      background: "transparent",
      textTransform: "capitalize",
      flex: "none",
      color: theme.palette.primary.main,
      "& svg": {
        verticalAlign: "middle",
      },
      "& .content": {
        fontSize: 16,
      },
      "&:hover": {
        background: "transparent",
      },
    },
  },
}));
